/* 徐晃（字公明） */
import { defineHero, U, S } from '../define.ts';

export default defineHero({
  id: 'xuhuang', name: '徐晃', sub: '字公明', faction: 'wei', role: '戰士/輔助', weapon: 'axe',
  look: { eye: 'narrow', beard: 'goatee', fx: '#e8c25a', c: { plume: '#8a1f2a', metal: '#5a6275' } },
  skills: [
    ['大地崩裂', 'spikes', '重擊地面，裂痕直線延伸，造成 {75/100/125/150} 傷害，距離隨等級增加。', { x: { k: 'line', dmg: [75, 100, 125, 150], rad: 40, speed: 900, shape: 'rock' }, aim: { kind: 'dir', range: [400, 480, 560, 640], width: 40 }, cd: 30, mp: 100 }],
    // v0.5.2：不再犧牲 50% 攻速
    ['大地之力', 'buff', '攻擊力 +{40/60/80/100}%，持續 18 秒。', { x: { k: 'buff', atkP: [40, 60, 80, 100], dur: 18 }, cd: 40, mp: 85 }],
    ['巨斧擊', 'multi', '巨斧奮力一擊，造成 {100/150/200/300} 傷害；25% 機率追加 {75/125/175/225}。', { x: { k: 'nuke', dmg: [100, 150, 200, 300], extra: { chance: 25, dmg: [75, 125, 175, 225] }, fx: 'slam' }, aim: U(150), mp: [100, 110, 120, 130] }],
    ['大地之怒', 'roar', '暴震地面召喚十字石陣，對周圍造成 {300/400/500} 傷害並震暈 {1/1.5/2} 秒。', { x: { k: 'aoe', self: true, dmg: [300, 400, 500], r: 300, cc: { stun: [1, 1.5, 2] }, ground: true, fx: 'slam' }, aim: S(300), cd: 150, mp: [180, 240, 300], el: 'earth' }],
  ],
});
